import { RoleOptions, Roles } from "common";
import { useGetProfileQuery } from "redux/services/membership";

export const useGetUserRole = () => {
  const { data: userData } = useGetProfileQuery();
  return {
    [`is${Roles.EnterpriseBankAdmin}`]: userData?.data?.listRoles?.includes(
      Roles.EnterpriseBankAdmin
    ),
    [`is${Roles.EnterpriseAdmin}`]: userData?.data?.listRoles?.includes(
      Roles.EnterpriseAdmin
    ),
    [`is${Roles.EnterprisePaymentOperation}`]:
      userData?.data?.listRoles?.includes(Roles.EnterprisePaymentOperation),
    [`is${Roles.EnterpriseSalesTeamMember}`]:
      userData?.data?.listRoles?.includes(Roles.EnterpriseSalesTeamMember),
    [`is${Roles.EnterpriseDeveloper}`]: userData?.data?.listRoles?.includes(
      Roles.EnterpriseDeveloper
    ),
    [`is${Roles.Member}`]: userData?.data?.listRoles?.includes(Roles.Member),
    userData: RoleOptions.find((role) =>
      userData?.data?.listRoles?.includes(role.value)
    )?.data || {
      homepage: "/",
      userGuide: "EnterpriseBankAdmin",
    },
  };
};
